export default __webpack_public_path__ + "static/media/ID_2.ccada3c9.png";